import axios from '../../utils/axios';
import i18n from '../../i18n';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const buildResponse = (data) => ({
  success: data.success,
  status: data.status,
  message: data.message,
  data,
});

const buildErrorResponse = (err) => {
  const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
  const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
  const errorMessage = (err.response && err.response.data && err.response.data.data)
    ? err.response.data.data.errorMessage : i18n.t('teleaudit.price.errors.generic');

  return {
    success: false,
    status,
    message,
    data: {
      errorMessage,
    },
  };
};

const getWalmartAiResultsByQuestionResponse = async (questionResponseId) => {
  try {
    const { data } = await axios.get(`/api/walmart-ai/results/question-response/${questionResponseId}`);
    return buildResponse(data);
  } catch (err) {
    return buildErrorResponse(err);
  }
};

const postWalmartAiProductTeleaudit = async (inputValues) => {
  try {
    const { data } = await axios.post('/api/walmart-ai/product-teleaudit', inputValues);
    return buildResponse(data);
  } catch (err) {
    return buildErrorResponse(err);
  }
};

export {
  getWalmartAiResultsByQuestionResponse,
  postWalmartAiProductTeleaudit,
};
